import React, { useEffect, useMemo, useState, useRef } from 'react'
import { observer } from 'mobx-react'
import { AppStore, GameLibraryStore } from 'src/pc/store/AppStore'
import { UserInfoHS, orderPreBalanceHS } from 'src/commons/store/UserStore'
import { commonJump, getVipGoodsByChannel } from 'src/pc/store/UIController'
import { GetChannel } from 'src/commons/utils'
import { useWaitModData } from '@hhpack/use-cms'
import { useThrottleFn } from 'ahooks'
import useVipStatus from 'src/pc/components/hooks/useVipStatus'
import styled from 'styled-components'
import DDModal from 'src/pc/components/DDModal'
import close from 'src/pc/assets/images/yearUpdateForever/close.png'
import btn from 'src/pc/assets/images/yearUpdateForever/btn.png'
import icon1 from 'src/pc/assets/images/yearUpdateForever/icon1.png'
import icon2 from 'src/pc/assets/images/yearUpdateForever/icon2.png'
import icon3 from 'src/pc/assets/images/yearUpdateForever/icon3.png'

type TUpdateForeverModalConfig = {
  pic: string
  user: '2' | '3'
  jump: 'in' | 'out'
  url: string
}

const UpdateForeverModal: React.FC = () => {
  const { isYearVip, isExpeVip } = useVipStatus()
  const [config, setConfig] = useState<TUpdateForeverModalConfig[]>()
  const [vipGoodsDetail, setVipGoodsDetail] = useState<VipConfigInstance>()
  const [upgradeForeverReduceAmt, setUpgradeForeverReduceAmt] = useState<number>()

  const cancel = () => {
    AppStore.expeYearUpdateForeverModalVisible = false
  }

  const loadConfig = async () => {
    const res = await useWaitModData<TUpdateForeverModalConfig>('simpleclient_vip_update_modal_config')
    setConfig(res)
  }

  const loadVipGoodsDetail = async () => {
    const finalVipGoodsList = await getVipGoodsByChannel()
    const currentVipGoods = finalVipGoodsList.find(d => d.vipType === 'forever')
    setVipGoodsDetail(currentVipGoods)
  }

  const loadUpdateForeverPrice = async () => {
    const res = await orderPreBalanceHS.Execute({
      gameId: vipGoodsDetail!.id,
      orderType: 21,
      useBalance: 0,
      channel: GetChannel(),
      boxVipType: 'forever',
    })
    setUpgradeForeverReduceAmt(res.payAmt)
  }

  const { run: _throttleClick } = useThrottleFn(
    () => {
      if (isExpeVip) {
        window.sensorsdataReportParams?.('expeupdatevipbox_Click', {
          position: AppStore.expeYearUpdateForeverModalPosition,
        })
      }
    },
    { leading: true, trailing: false, wait: 1000 },
  )

  const currentVipConfig = useMemo(() => {
    if (isYearVip) {
      return config?.find(d => d?.user === '2')
    }
    if (isExpeVip) {
      return config?.find(d => d?.user === '3')
    }
  }, [config, isExpeVip, isYearVip])

  const visible = useMemo(() => {
    return (isYearVip || isExpeVip) && AppStore.expeYearUpdateForeverModalVisible
  }, [AppStore.expeYearUpdateForeverModalVisible, isYearVip, isExpeVip])

  useEffect(() => {
    if (visible) {
      AppStore.expeYearUpdateForeverModalTimer && window.clearTimeout(AppStore.expeYearUpdateForeverModalTimer)
    }
    if (isExpeVip && visible) {
      window.gogReport?.('expeupdatevipbox_View')
    }
  }, [visible, isExpeVip])

  useEffect(() => {
    if (GameLibraryStore.gameRunStatus === 'stop') {
      AppStore.expeYearUpdateForeverModalTimer && window.clearTimeout(AppStore.expeYearUpdateForeverModalTimer)
    }
  }, [GameLibraryStore.gameRunStatus])

  useEffect(() => {
    if ((isExpeVip || isYearVip) && vipGoodsDetail) {
      loadUpdateForeverPrice()
    }
  }, [isExpeVip, isYearVip, vipGoodsDetail])

  useEffect(() => {
    loadConfig()
    loadVipGoodsDetail()
  }, [])

  return (
    <>
      <StyledModal
        visible={visible}
        // visible={true}
        width={537}
        className="custom-1 UpgradeModal"
        closable={false}
        centered
        maskClosable={false}
        title={null}
        footer={null}
        bg={currentVipConfig?.pic || ''}
      >
        <div className="title">现在开通低至{upgradeForeverReduceAmt}元</div>
        <StyledGoodsList>
          {vipGoodsDetail?.vipGiveJsqDesc && (
            <StyledGoodsListItem>
              <img src={icon1} />
              <div>送{vipGoodsDetail?.vipGiveJsqDesc}</div>
            </StyledGoodsListItem>
          )}
          {vipGoodsDetail?.buyVipWeBuffDesc && (
            <StyledGoodsListItem>
              <img src={icon2} />
              <div>送{vipGoodsDetail?.buyVipWeBuffDesc}</div>
            </StyledGoodsListItem>
          )}
          {vipGoodsDetail?.vipCustomerServiceDesc && (
            <StyledGoodsListItem>
              <img src={icon3} />
              <div>{vipGoodsDetail?.vipCustomerServiceDesc}</div>
            </StyledGoodsListItem>
          )}
        </StyledGoodsList>
        <StyledBtn
          src={btn}
          onClick={() => {
            commonJump(currentVipConfig?.url || '/vip', currentVipConfig?.jump === 'out')
            AppStore.expeYearUpdateForeverModalVisible = false
            _throttleClick()
          }}
        />
        <StyledClose onClick={() => cancel()}>
          <img draggable={false} src={close} />
        </StyledClose>
      </StyledModal>
    </>
  )
}

/**
 * 是否显示永久会员升级活动弹窗
 */
export const checkYearUpdateForeverModal = async (position: 'home' | 'start' | 'game' = 'home') => {
  if (AppStore.expeYearUpdateForeverModalVisible) {
    return
  }
  const token = localStorage.getItem('php-token')
  if (!token) {
    return false
  }
  const userInfo = await UserInfoHS.Execute({ token })
  const isYearVip = !!userInfo && userInfo.vip === 2 && userInfo.super_vip_type === 'year'
  const isExpeVip = !!userInfo && userInfo.vip === 2 && userInfo.super_vip_type === 'expe'

  const modalFlag = localStorage.getItem(`year-update-forever-modal-${position}`) === '1'

  //启动游戏次数
  const startSuccessNum = Number(localStorage.getItem(`start-game-success-num`))

  //启动成功30min
  if (position === 'game' && (isYearVip || isExpeVip) && !modalFlag && startSuccessNum > 0) {
    AppStore.expeYearUpdateForeverModalVisible = true
    localStorage.setItem('year-update-forever-modal-game', '1')
    AppStore.expeYearUpdateForeverModalPosition = 'home'
    return true
  }

  // 启动游戏成功3次
  if (position === 'start' && (isYearVip || isExpeVip) && !modalFlag && startSuccessNum >= 3) {
    AppStore.expeYearUpdateForeverModalVisible = true
    localStorage.setItem('year-update-forever-modal-start', '1')
    AppStore.expeYearUpdateForeverModalPosition = 'start'
    return true
  }

  // 首页
  if (position === 'home' && (isYearVip || isExpeVip) && !modalFlag) {
    AppStore.expeYearUpdateForeverModalVisible = true
    localStorage.setItem('year-update-forever-modal-home', '1')
    AppStore.expeYearUpdateForeverModalPosition = 'home'
    return true
  }
  return false
}
const StyledGoodsListItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 104px;
  height: 86px;
  background: rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  padding: 0 3px;
  div {
    font-size: 12px;
    color: #d9d9d9;
    text-align: center;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 13px;
  }
`
const StyledGoodsList = styled.div`
  position: absolute;
  top: 293px;
  left: 109px;
  width: 330px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const StyledBtn = styled.img`
  position: absolute;
  bottom: 106px;
  left: 109px;
  cursor: pointer;
  display: block;
  &:hover {
    filter: brightness(1.1);
  }
`
const StyledClose = styled.div`
  position: absolute;
  top: 101px;
  right: 66px;
`
const StyledModal = styled(DDModal)<{ bg: string }>`
  .ant-modal-content {
    background: url(${prop => prop.bg}) no-repeat;
  }
  .ant-modal-body {
    background: none;
    padding-top: 60px;
    height: 551px;
  }
  .ant-modal-close-x {
    display: none;
  }
  .title {
    height: 38px;
    font-size: 26px;
    color: #ffffff;
    line-height: 38px;
    position: absolute;
    font-weight: bold;
    left: 110px;
    top: 235px;
  }
`

export default observer(UpdateForeverModal)
